import logo from "./img/logo.png";
import background from "./img/main.jpg";
import about from "./img/about.jpg";

const option1 = true;

export const Data = {
  companyName: "Votre compagnie",
  companyLogo: logo,
  companySiret: "123456789",
  companyEmail: "votremail@votresite.com",
  companyPhone: "+33 1 23 45 67 89",
  companyAdress: "123 votre rue, 12345 votre ville",
  backgroundImage: background,
  websiteName: "votre-site.vercel.app",
  navTitle: "Menu",
  homeTitle: "Bienvenue!",
  homeDescritpion:
    "Explorez les délices de l'Asie dans notre restaurant. Saveurs authentiques, ingrédients frais, et ambiance accueillante vous attendent. Réservez maintenant pour un voyage culinaire mémorable.",
  aboutTitle: "Menu",
  aboutOptionOne: false,
  aboutOption1: {
    aboutTitle1: "Produit",
    aboutDescription1:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Delectus sint repellendus fugiat eveniet nobis eaque ratione reiciendis minus! Quibusdam adipisci possimus quaerat voluptatem exercitationem quod tempora iure ducimus, quia dolore.",
    aboutTitle2: "Produit",
    aboutDescription2:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Delectus sint repellendus fugiat eveniet nobis eaque ratione reiciendis minus! Quibusdam adipisci possimus quaerat voluptatem exercitationem quod tempora iure ducimus, quia dolore.",
    aboutTitle3: "Produit",
    aboutDescription3:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Delectus sint repellendus fugiat eveniet nobis eaque ratione reiciendis minus! Quibusdam adipisci possimus quaerat voluptatem exercitationem quod tempora iure ducimus, quia dolore.",
  },
  aboutOption2: {
    aboutImage: about,
  },
  contactTitle: "Contact",
  phone: "+33 1 23 45 67 89",
  facebook: "@facebook",
  instagram: "@instagram",
  email: "votremail@votresite.com",
  pinterest: "@pinterest",
  address: `123 votre rue, 
  35800 Votre Ville`,
};
